import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Location } from '@angular/common';
import { IEpRadioButtonData, EpButtonStyle, EpButtonSize, EpEventService } from '@epicor/kinetic';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';
import { EpbtFaCustomerService } from '../../services/epbt-fa-customer.service';
import { SaleType, PageNames } from 'ep-bt-controls';
import { Branch, BisTrackSettingsAutomaticallyApplyWebTrackSalesOrders } from 'ep-bt-field-agent-proxy';
import { QuickOrderModel } from '../../models/quick-order.model';
import { EpbtFaBistrackbranchesListComponent } from '../../list/epbt-fa-bistrackbranches-list/epbt-fa-bistrackbranches-list.component';
import { EpbtFaQuickOrderSummaryService } from '../../services/epbt-fa-quick-order-summary.service';
import { SearchPageNames, CustomEvents, DialogPageNames } from 'ep-bt-controls';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';
import { EpbtFaCustomerSearchComponent } from '../epbt-fa-customer-search/epbt-fa-customer-search.component';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-new-quick-order-customer',
  templateUrl: './epbt-fa-new-quick-order-customer.component.html',
  styleUrls: ['./epbt-fa-new-quick-order-customer.component.scss']
})
export class EpbtFaNewQuickOrderCustomerComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private location: Location,
    public quickOrderService: EpbtFaQuickOrderService, private customerService: EpbtFaCustomerService,
    public epEvent: EpEventService, public quickOrderSummaryService: EpbtFaQuickOrderSummaryService,
    private sortService: EpbtFaSortService, private faService: EpbtFieldAgentService) {
    this.epEvent.onEvents([CustomEvents.QuickOrderCustomer]).subscribe(event => {
      this.customerSearchString = event.data ? event.data : '';
      this.sortService.customerSearchValue = this.customerSearchString;
      this.onSearchCustomerClick('');
    });
  }

  // This will be use in html code for validation
  get frmFields() { return this.newOrderCustomerForm.controls; }

  EpButtonStyle = EpButtonStyle;
  EpButtonSize = EpButtonSize;

  public transactionTypeData: Array<IEpRadioButtonData> = [{ value: 1, label: 'Order' },
  { value: 2, label: 'Quote' }];
  public salesTypeData: Array<IEpRadioButtonData> = [];

  newOrderCustomerForm: FormGroup;
  submitted = false;
  taxAreaLabel = 'Tax Area*';

  customerPageName: string = SearchPageNames.QuickOrderCustomer;
  customerSearchString: string;
  customerPlaceholder = 'Search Customers';
  pageNames = PageNames;
  errorCustomer: any;

  @ViewChild(EpbtFaBistrackbranchesListComponent, { static: false }) epbtFaBistrackbranchesListComponent: EpbtFaBistrackbranchesListComponent;
  @ViewChild(EpbtFaCustomerSearchComponent, { static: false }) searchComponent: EpbtFaCustomerSearchComponent;

  @Output() customerChange = new EventEmitter<any>();
  @Output() selectCustomerSearch = new EventEmitter<any>();

  receiveCustomerString($event) {
    this.customerSearchString = $event;
  }

  ngOnInit() {
    if (!this.quickOrderService.quickOrder) {
      this.quickOrderService.quickOrder = new QuickOrderModel();
    }

    this.faService.getBisTrackSetting((bisTrackSettings: any) => {
      this.quickOrderService.bisTrackSettings = bisTrackSettings;
      this.quickOrderSummaryService.bisTrackSettings = bisTrackSettings;
      this.quickOrderSummaryService.geti4goTrueTokenParameters((result: any) => {
      });
      if (this.quickOrderService.bisTrackSettings
        && this.quickOrderService.bisTrackSettings.automaticallyApplyWebTrackSalesOrders == BisTrackSettingsAutomaticallyApplyWebTrackSalesOrders.YesComplete) {
        this.salesTypeData = [
          { value: 1, label: 'Pickup Now' },
          { value: 2, label: 'Will Call' },
          { value: 3, label: 'Delivered' }
        ];

        if (!this.quickOrderService.quickOrder.selectedSalesType) {
          this.quickOrderService.quickOrder.selectedSalesType = SaleType.CollectLater;
        }
      } else {
        this.salesTypeData = [
          { value: 2, label: 'Will Call' },
          { value: 3, label: 'Delivered' }
        ];

        if (!this.quickOrderService.quickOrder.selectedSalesType) {
          this.quickOrderService.quickOrder.selectedSalesType = SaleType.CollectLater;
        }
      }
    });

    if (this.quickOrderService.quickOrder.customer &&
      this.quickOrderService.selectedBranchId != -1 &&
      this.quickOrderService.quickOrder.selectedSalesType &&
      this.quickOrderService.quickOrder.deliveryAddress) {
      this.quickOrderService.SetDefaultTaxArea();
    }

    this.newOrderCustomerForm = this.formBuilder.group({
      dateRequired: [this.quickOrderService.quickOrder.dateRequired ? this.quickOrderService.quickOrder.dateRequired : new Date()],
      transactionType: [this.quickOrderService.selectedTransactionType],
    });

    this.disableOrderType();
  }

  onValueChange(selectedValue: any): void {
    if (selectedValue instanceof Branch) {
      this.quickOrderService.selectedBranchId = selectedValue.branchID;
      this.quickOrderService.quickOrder.branch = selectedValue;
      this.quickOrderService.SetDefaultTaxArea();
    } else {
      this.quickOrderService.selectedTextAreaId = selectedValue.taxAreaID;
      this.quickOrderService.quickOrder.taxArea = selectedValue;
    }
  }

  onTransactionTypeChange(event: any) {
    this.quickOrderService.selectedTransactionType = this.newOrderCustomerForm.controls['transactionType'].value;
    this.quickOrderService.quickOrder.TransactionType = this.newOrderCustomerForm.controls['transactionType'].value;
    this.onSubmit();
  }

  onSalesTypeChange(selectedValue: any) {
    this.quickOrderService.quickOrder.selectedSalesType = selectedValue;
    this.quickOrderService.SetDefaultTaxArea();
    this.onSubmit();
  }

  onSubmit() {
    this.submitted = true;
    this.quickOrderService.customerFormFlag = true;
    if (!this.quickOrderService.quickOrder.customer || !this.validateCustomer() || this.newOrderCustomerForm.invalid ||
    this.quickOrderService.selectedTextAreaId <= 0 || this.quickOrderService.selectedBranchId < 0) {
      if (!this.quickOrderService.quickOrder.customer) {
        this.errorCustomer = 'Please select a customer';
      }
      this.quickOrderService.customerFormFlag = false;
    } else {
      if (this.quickOrderService.selectedBranchId > 0 && !this.quickOrderService.quickOrder.branch) {
        const result = this.epbtFaBistrackbranchesListComponent.bisTrackBranches.filter(x => x.branchID == this.quickOrderService.selectedBranchId);
        this.quickOrderService.quickOrder.branch = result ? result[0] : null;
      }
      this.quickOrderService.customerFormFlag = true;
    }
  }

  // Bind the existing values
  bindValuesToForm() {
    this.newOrderCustomerForm.patchValue({
      dateRequired: this.quickOrderService.quickOrder.dateRequired ? this.quickOrderService.quickOrder.dateRequired : new Date(),
      transactionType: this.quickOrderService.selectedTransactionType
    });
  }

  onSearchCustomerClick(event: any) {
    this.errorCustomer = '';
    const searchString = this.customerSearchString;
    this.customerService.searchString = searchString;
    if (this.quickOrderService.isNewOrder) {
      this.updateBranch();
    }

    this.customerService.fromPage = PageNames.QuickOrder;
    if (searchString) {
      this.customerService.getCustomers(searchString, 0, (customers: any) => {
        if (customers && customers.length == 1) {
          this.quickOrderService.quickOrder.deliveryAddress = null;
          this.quickOrderService.selectedTextAreaId = -1;
          this.quickOrderService.quickOrder.taxArea = null;
          this.quickOrderService.quickOrder.contact = null;
          this.customerService.selectedCustomer = customers[0];
          this.customerSearchString = this.customerService.selectedCustomer.name;
          this.updateSearchValue();
          this.quickOrderService.setCustomer(customers[0], (flag: any) => {
            this.disableOrderType();
            this.bindValuesToForm();
            this.quickOrderService.SetDefaultTaxArea();
            this.customerChange.emit();
          });
        } else {
          this.selectCustomerSearch.emit({ dialog: DialogPageNames.CustomerSearch, searchString: searchString });
        }
      });
    } else {
      this.selectCustomerSearch.emit({ dialog: DialogPageNames.CustomerSearch, searchString: this.customerSearchString ? this.customerSearchString : '' });
    }
  }

  updateSearchValue() {
    this.customerSearchString = this.customerService.selectedCustomer.name;
    this.searchComponent.updateSearchValue(this.customerService.selectedCustomer.name);
  }

  onSearchCustomerButtonClick(event: any) {
    this.customerService.fromPage = PageNames.QuickOrder;
    this.selectCustomerSearch.emit({ dialog: DialogPageNames.CustomerSearch, searchString: this.customerSearchString ? this.customerSearchString : '' });
    if (this.quickOrderService.isNewOrder) {
      this.updateBranch();
    }
  }

  // This is used only for new order
  updateBranch() {
    if (this.quickOrderService.selectedBranchId > 0 && !this.quickOrderService.quickOrder.branch) {
      const result = this.epbtFaBistrackbranchesListComponent.bisTrackBranches.filter(x => x.branchID == this.quickOrderService.selectedBranchId);
      this.quickOrderService.quickOrder.branch = result ? result[0] : null;
    }
  }

  validateCustomer(): boolean {
    if (!this.customerSearchString || !this.quickOrderService.quickOrder.customer) {
      this.errorCustomer = 'Please select a customer';
      return false;
    } else if (this.customerSearchString != this.quickOrderService.quickOrder.customer.name) {
      this.errorCustomer = 'Please select a customer';
      return false;
    } else {
      this.errorCustomer = '';
      return true;
    }
  }

  disableOrderType() {
    this.transactionTypeData.find(item => item.value == 1).disabled = this.quickOrderService.isOrderDisable;
    this.quickOrderService.isOrderDisable = false;
  }

  detailsIcon() {
    this.epEvent.broadcast(CustomEvents.CustomerDetailIcon);
  }
}
